<template>
  <div class="fixed-header" :class="{ mobile: $vuetify.breakpoint.smAndDown }">
    <!-- if has summary fields add class 'with-summary' -->
    <v-layout align-center fill-height class="fixed-header-wrapper">
      <v-flex shrink class="text-truncate" pr-4>
        <v-tooltip color="secondary" bottom>
          <template v-slot:activator="{ on }">
            <h2 v-on="on" class="p-relative text-truncate">{{header}}</h2>
          </template>
          <span>{{header}}</span>
        </v-tooltip>
        <h4 class="pt-1 sub-header">
          {{subheader}}
        </h4>
      </v-flex>
      <v-spacer></v-spacer>
      <!-- <v-divider vertical></v-divider>
      <v-flex shrink fill-height class="action">
        <v-tooltip left color="secondary">
          <v-btn icon flat slot="activator" :to="newItemPath">
            <v-icon color="success" size="24">add_circle</v-icon>
          </v-btn>
          <span>Create a new case template</span>
        </v-tooltip>
      </v-flex> -->
    </v-layout>
  </div>
</template>

<script>
export default {
  name: "CaseConfigHeader",
  props: {
    header: {
      type: String,
      required: true
    },
    subheader: {
      type: String,
      required: true
    }
  }
}
</script>